import { type MCPServerInfo } from '../../types';

const GoogleSlidesServer: MCPServerInfo = {
  serverId: 'GOOGLE_SLIDES',
  name: 'Google Slides',
  slug: 'google-slides',
  description:
    'Google Slides MCP Server for creating and editing presentations',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/google-mcp-servers',
    commitSha: 'f86a7e2e',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default GoogleSlidesServer;
